import './index.scss';
import { TGetChatHistoryListResponse } from '../../../utils/types/agrocraftArtisan';
import HistoryIcon from '@mui/icons-material/History';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';

export const ChatHistory = ({
  setSessionId,
  chatHistoryList,
  userId,
}: {
  setSessionId: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  chatHistoryList:
    | TGetChatHistoryListResponse[]
    | undefined;
  userId: string | null;
}) => {
  return (
    <div className="agrocraft-artisian-sidebar overflow-auto">
      <div className="px-4">
        {!userId && (
          <div
            className="sidebar-newprompt cursor-pointer"
            onClick={() => {
              appLogEvent(CUSTOM_EVENTS.NEW_PROMPT_CLICK);
              setSessionId(undefined);
            }}>
            <BorderColorIcon
              style={{ marginRight: '16px' }}
            />
            <span>New Prompt</span>
          </div>
        )}
        <div
          className="sidebar-history"
          style={{ marginTop: userId ? '22px' : '0px' }}>
          <HistoryIcon style={{ marginRight: '6px' }} />
          <span>History</span>
        </div>
      </div>
      <div className="sidebar-historyitems px-4">
        {chatHistoryList && chatHistoryList?.length > 0
          ? chatHistoryList.map((historyItem) => (
              <div
                key={historyItem.Id}
                className="historyitem"
                onClick={() => {
                  appLogEvent(
                    CUSTOM_EVENTS.HISTORY_ITEM_CLICKED,
                    { historyItemId: historyItem.Id }
                  );
                  setSessionId(historyItem.Id);
                }}>
                {historyItem.Name}
              </div>
            ))
          : 'No History found'}
      </div>
    </div>
  );
};
